var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cart"},[(_vm.noData)?_c('p',[_vm._v(_vm._s(_vm.title)+" "),_c('br'),_c('span',{staticClass:"no-data-info"},[_vm._v("No data to show")])]):_c('v-chart',{staticClass:"chart",attrs:{"option":_vm.options,"autoresize":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }